/* eslint-disable import/prefer-default-export */
import { dictionary as enGbLocaleDictionary } from 'src/locales/en-gb'
import { dictionary as enUsLocaleDictionary } from 'src/locales/en-us'
import { LocaleDictionary } from 'src/locales/LocaleDictionary'

/**
 * Custom hook to provide the locale dictionary based on the current locale, used for translation purposes.
 *
 * Defaults to the `en-us` dictionary if the current locale is not recognized or not set.
 */
export const useLocaleDictionary = (): LocaleDictionary => {
  const currentLocale = process.env.PRISMIC_LOCALE

  switch (currentLocale) {
    case 'en-us':
      return enUsLocaleDictionary
    case 'en-gb':
      return enGbLocaleDictionary

    // Default to en-us if the locale is not recognized or not set.
    default:
      return enUsLocaleDictionary
  }
}
